/**
 * Moved out of apps/app's global index.css (#18911) — these Cloudinary-hosted `@font-face` rules
 * were previously loaded on every page for every user regardless of whether their presentation
 * contains a Benjamin Moore section.
 */
export const BENJAMIN_MOORE_FONT_FACE_CSS = `
@font-face {
  font-family: 'Moderat-CustomFont-BM';
  src: url('https://res.cloudinary.com/taptapquote/raw/upload/v1709849283/paintscout/partners/benjamin-moore/fonts/Moderat-Light.otf')
    format('opentype');
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'MacklinDisplay-CustomFont-BM';
  src: url('https://res.cloudinary.com/taptapquote/raw/upload/v1709849283/paintscout/partners/benjamin-moore/fonts/MacklinDisplay-Medium.otf')
    format('opentype');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
`
